import { Text, useBreakpointValue } from "native-base";
import React from "react";

import SimpleWebHeader from "@/components/molecules/SimpleWebHeader";
import Container from "@/components/organisms/Container";

import FormLoading from "../components/FormLoading";
import { SignUpFormScreenProps } from "../types";
import Form from "./components/Form";
import { CustomerFormData } from "./schema";

type SignUpCustomerWebProps = SignUpFormScreenProps<CustomerFormData>;

const SignUpCustomerWeb = ({
  isLoading,
  isSubmiting,
  onCancel,
  onSubmit,
}: SignUpCustomerWebProps) => {
  const paddingX = useBreakpointValue({
    base: "1/5",
    xl: "1/4",
    "2xl": "1/3",
  });
  return (
    <Container Header={<SimpleWebHeader />} px={paddingX}>
      <Text fontSize="2xl" py="6">
        Cadastre-se
      </Text>
      {isLoading ? (
        <FormLoading numberOfFields={6} />
      ) : (
        <Form isSubmiting={isSubmiting} onCancel={onCancel} onSubmit={onSubmit} />
      )}
    </Container>
  );
};

export default SignUpCustomerWeb;
